// extracted by mini-css-extract-plugin
export default {"container":"ImageGenerator_container__TJH7b","content":"ImageGenerator_content__ueITp","text":"ImageGenerator_text__DIYqU","downloadButton":"ImageGenerator_downloadButton__93xeI"};